import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class VersionService {
  constructor(private http: HttpClient) {}
  get(): Observable<string> {
    return this.http.get(`/api/version`, { responseType: "text" });
  }

  getIsDocker(): Observable<boolean> {
    return this.http.get<boolean>(`/api/version/is-docker`);
  }
}
